import { z } from 'zod';
import { ProductDecoder } from './ProductDto';

export const ProductsDecoder = z.array(ProductDecoder);

export type ProductsDto = z.infer<typeof ProductsDecoder>;
